import React from 'react';

// Uma casa da grade. `React.memo` com PROPS PRIMITIVAS APENAS (mais o handler, que o
// Canvas mantém estável): é o que faz um clique re-renderizar UMA casa e não a grade inteira.
// Mesmo padrão de `crossword/Cell.tsx` e `wordsearch/Cell.tsx`.
//
// Nada de contexto aqui dentro — a casa não assina nem doc nem ui.

export interface CellProps {
  /** Posição row-major no documento (0..size²-1) — é o que volta no `onToggle`. */
  index: number;
  /** Linha 0-based, só para a borda dos blocos e o rótulo acessível. */
  row: number;
  /** Coluna 0-based. */
  col: number;
  /** Dígito da solução (1..size). Só aparece quando a casa é dada. */
  digit: number;
  /** A casa vem preenchida para o jogador? */
  given: boolean;
  editavel: boolean;
  /** Lado da grade (9 ou 15). */
  size: number;
  /** Colunas por bloco. */
  boxW: number;
  /** Linhas por bloco. */
  boxH: number;
  /** Lado da casa em pixels. */
  px: number;
  onToggle: (index: number) => void;
}

const GRID_LINE = '1px solid #d9d9d9';
/** Linha grossa: separa os blocos e fecha a moldura. */
const BLOCK_LINE = '2px solid #434343';

const CellComponent: React.FC<CellProps> = ({
  index,
  row,
  col,
  digit,
  given,
  editavel,
  size,
  boxW,
  boxH,
  px,
  onToggle,
}) => (
  <button
    type="button"
    data-testid={`cell-${index}`}
    // Rótulo explícito de linha e coluna: no sudoku o eixo `x` do blob é a LINHA
    // (§4.2), então "cell-3-5" seria ambíguo para quem lê o teste.
    aria-label={`Linha ${row + 1}, coluna ${col + 1}`}
    aria-pressed={given}
    disabled={!editavel}
    onClick={() => onToggle(index)}
    style={{
      width: px,
      height: px,
      padding: 0,
      borderTop: row % boxH === 0 ? BLOCK_LINE : GRID_LINE,
      borderLeft: col % boxW === 0 ? BLOCK_LINE : GRID_LINE,
      borderRight: col === size - 1 ? BLOCK_LINE : GRID_LINE,
      borderBottom: row === size - 1 ? BLOCK_LINE : GRID_LINE,
      fontSize: px >= 40 ? 18 : 13,
      lineHeight: '18px',
      fontWeight: given ? 600 : 400,
      color: '#141414',
      background: given ? '#f0f5ff' : '#fff',
      cursor: editavel ? 'pointer' : 'not-allowed',
      userSelect: 'none',
    }}
  >
    {/* A casa vazia é a que o jogador vai preencher — ela aparece em branco aqui
        também, para o admin ver o tabuleiro como o jogador vai receber (§8). */}
    {given && digit > 0 ? digit : ''}
  </button>
);

export const Cell = React.memo(CellComponent);
